export default __webpack_public_path__ + "static/media/ZZC_0969.5e2aee43.jpg";